import styled from 'styled-components';
import { StyledDiv } from '../../../Theme/CommonStyled';

export const StyledNotificationContainer = styled.div`
  padding: 14px;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  margin-bottom: 10px;
  direction: rtl;
  cursor: pointer;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;

export const StyledMessage = styled.div`
  text-overflow: ellipsis; /* enables ellipsis */
  white-space: nowrap; /* keeps the text in a single line */
  overflow: hidden; /* keeps the element from overflowing its parent */
  font-size: ${({ theme }): string => theme.fontSizes[2]};
  color: ${({ theme }): string => theme.colors.secondaryText};
`;

export const StyledModalContent = styled(StyledDiv)<{ type?: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  padding: 14px;
  margin-bottom: ${({ type }): string => (type === 'message' ? '0' : '10px')};
`;

export const StyledMessageContent = styled.div`
  font-size: ${({ theme }): string => theme.fontSizes[2]};
  :not(:last-of-type) {
    margin-bottom: 12px;
  }
`;
